/**
 * Creado por Norte70
 * @author Heriberto Monterrubio <heri185403@gmail.com>
 * @Date 08/01/2021
 */
import * as SessionUtils from '@/core/session_utils.js'

const procedureMoveRequest = () => {
    return {
        session_token: SessionUtils.getGuestUserToken(),
        invited: SessionUtils.isGuestUser(),
        cart_item_id: 0,
        move_to: ''
    }
}

export default procedureMoveRequest;